/**
 * Artifact editor session bridge.
 *
 * Inline-edit analytics is emitted from a Redux listener, but the editor session id it reports
 * is owned by a React hook, and the pending-edit review renders in a different subtree
 * (`drafting/workspace`) from the editor itself. This registry carries the id across that gap,
 * mirroring how `getTrackEventGlobal` bridges the tracker into non-React workflows.
 *
 * Observational only: nothing here affects product behavior, and a missing entry degrades the
 * payload rather than blocking an event.
 */
const sessionIdByConversationId = new Map<string, string>()

export function setArtifactEditorSession(conversationId: string, sessionId: string): void {
  sessionIdByConversationId.set(conversationId, sessionId)
}

export function clearArtifactEditorSession(conversationId: string, sessionId: string): void {
  // Only the session that registered may clear it: a remount can register the next session
  // before the previous one's cleanup runs.
  if (sessionIdByConversationId.get(conversationId) === sessionId) sessionIdByConversationId.delete(conversationId)
}

/** Returns the open editor session for a conversation, or '' when no editor is mounted for it. */
export function getArtifactEditorSession(conversationId: string): string {
  return sessionIdByConversationId.get(conversationId) ?? ''
}
